export const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data.data;
  if (typeof list !== "object") {
    list = [];
  }
  return list;
};

export const dateFormat = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
};

export const numberFormat = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const GetBlobFileforDownload = async function (fileObj) {
  try {
    // console.log(fileObj);
    /* var fileURL = window.URL.createObjectURL(
      new Blob([fileObj.data.data.result.fileByte])
    ); */
    var fileLink = document.createElement("a");

    fileLink.href = fileObj.data.data.fileByte;
    fileLink.setAttribute("download", "priceOfferConfirmation.pdf");
    document.body.appendChild(fileLink);

    fileLink.click();
  } catch (error) {
    console.log(error);
  }
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
